<template>
    <div>
        <div class="text-h6 font-weight-bold my-2 text-darkblue">Les campagnes d'emails</div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped></style>